import { OnInit, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ConversationService } from '../services/conversation.service';
import { Router } from '@angular/router';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { LoadingSummaryService } from '../services/loading-summary.service';
var SearchbarComponent = /** @class */ (function () {
    function SearchbarComponent(conversationService, router, speechRecognitionService, changeDetector, loadingSummaryService) {
        var _this = this;
        this.conversationService = conversationService;
        this.router = router;
        this.speechRecognitionService = speechRecognitionService;
        this.changeDetector = changeDetector;
        this.loadingSummaryService = loadingSummaryService;
        this.profileView = false;
        this.isCard = false;
        this.hidden = false;
        this.enableSearch = false;
        this.keywordChanged = new EventEmitter();
        this.isBusy = false;
        this.speechApi = true;
        this.selectedValue = 'Current';
        this.setKeyword = '';
        this.sub = loadingSummaryService.loadingSummaryChanged$.subscribe(function (value) {
            if (_this.isBusy && !value) {
                _this.isBusy = false;
            }
        });
    }
    Object.defineProperty(SearchbarComponent.prototype, "keyword", {
        set: function (word) {
            if (word != "#trigger") {
                this.setKeyword = word;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchbarComponent.prototype, "setPlaceholder", {
        set: function (text) {
            if (text) {
                this.placeholder = text.toLowerCase();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchbarComponent.prototype, "summaryRefreshed", {
        set: function (bool) {
            if (this.isBusy) {
                this.isBusy = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchbarComponent.prototype.ngOnInit = function () {
        this.valueSelection = [];
        this.valueSelection.push({ ItemValue: "Current", ItemDisplay: "Current View" });
        this.valueSelection.push({ ItemValue: "Global", ItemDisplay: "Global View" });
    };
    SearchbarComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
    };
    SearchbarComponent.prototype.ngAfterViewChecked = function () {
        this.changeDetector.detectChanges();
    };
    SearchbarComponent.prototype.searchByKeyword = function (keyword) {
        var _this = this;
        this.isBusy = true;
        this.loadingSummaryService.setLoading(true);
        if (this.setKeyword == keyword) {
            this.keywordChanged.emit("#trigger");
        }
        this.setKeyword = keyword;
        setTimeout(function () {
            _this.keywordChanged.emit(keyword);
        });
    };
    SearchbarComponent.prototype.changeView = function (view) {
        // console.log(view);
        // this.selectedValue = view;
    };
    SearchbarComponent.prototype.searchGlobal = function (text) {
        var _this = this;
        this.isBusy = true;
        this.conversationService.converse(text).subscribe(function (result) {
            _this.isBusy = false;
            var resultObject = JSON.parse(result);
            if (resultObject.ReturnType == "0") {
                if (resultObject.Arguments) {
                    var path = [];
                    resultObject.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    _this.router.navigate(path);
                }
            }
        });
    };
    SearchbarComponent.prototype.activateSpeech = function () {
        //this.showSearchButton = false;
        var _this = this;
        this.speechRecognitionService.record()
            .subscribe(
        //listener
        function (value) {
            _this.speechData = value;
            console.log(value);
        }, 
        //error
        function (err) {
            console.log(err);
            if (err.error == "no-speech") {
                console.log("--restarting service--");
                _this.activateSpeech();
            }
        }, 
        //completion
        function () {
            //this.showSearchButton = true;
            console.log("--complete--");
            //this.activateSpeech();            
            _this.searchGlobal(_this.speechData);
        });
    };
    return SearchbarComponent;
}());
export { SearchbarComponent };
